<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-btn
                    icon
                    href="https://files.gestionuniformes.cl/unf/UploadMassiveProducts.xlsx"
                    target="_blank"
                >
                    <v-icon color="green">mdi-microsoft-excel</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-file-input
                                v-model="currentFile"
                                label="Seleccionar archivo Excel (.xlsx, .xls)"
                                accept=".xlsx, .xls"
                                placeholder="Haz clic para buscar el archivo"
                                prepend-icon="mdi-microsoft-excel"
                                outlined
                                dense
                                @change="resetData"
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn
                                color="success"
                                class="white--text"
                                :disabled="!currentFile"
                                @click="readExcelFile"
                                block
                            >
                                Procesar Archivo
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div v-if="excelData.length > 0">
                        <v-divider class="my-3"></v-divider>
                        <p class="subtitle-1">
                            Vista previa de datos ({{ excelData.length }}
                            filas):
                        </p>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-data-table
                            :headers="headers"
                            :items="excelData"
                            :items-per-page="5"
                            :search="search"
                            class="elevation-1 custom-font"
                        >
                            <template v-slot:item.flag="{ item }">
                                <v-icon :color="item.flag ? 'green' : 'red'">
                                    {{
                                        item.flag
                                            ? "mdi-check-circle"
                                            : "mdi-alert-circle"
                                    }}
                                </v-icon>
                            </template>
                            <template v-slot:item.errors="{ item }">
                                <v-chip
                                    v-if="item.errors && item.errors.length > 0"
                                    small
                                    color="error"
                                    text-color="white"
                                    class="ma-1"
                                    v-for="(error, index) in item.errors.split(
                                        ', ',
                                    )"
                                    :key="index"
                                >
                                    {{ error }}
                                </v-chip>
                                <span v-else>-</span>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else-if="loading" class="text-center py-5">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
                        <p>Leyendo archivo...</p>
                    </div>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-alert shaped dense dark type="error" v-if="hasErrors">
                    Se han detectado filas con errores. No se puede continuar
                    hasta corregirlos.
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelAction">
                    Cancelar
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="confirmData"
                    v-if="excelData.length > 0 && !hasErrors"
                >
                    Cargar Productos
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import { headersProducts } from "../commons/headers";
export default {
    name: "UploadMassiveProducts",
    props: {
        title: {
            type: String,
            default: "Actualizar Precios",
        },
        products: {
            type: Array,
            default: () => [],
        },
        suppliers: {
            type: Array,
            default: () => [],
        },
        categories: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        currentFile: null,
        excelData: [],
        headers: headersProducts,
        loading: false,
        error: false,
        search: "",
        hasErrors: false,
    }),
    mounted() {},
    methods: {
        // Limpia la tabla si el usuario cambia el archivo
        resetData() {
            this.excelData = [];
            this.hasErrors = false;
        },

        cancelAction() {
            this.$emit("cancelStock");
            this.currentFile = null;
            this.resetData();
        },

        async confirmData() {
            // Solo enviar productos válidos (con flag = true)
            const validProducts = this.excelData.filter((row) => row.flag);

            const productsToSend = validProducts.map((row) => ({
                categoryId: row.categoryId,
                name: String(row.code),
                size: row.size,
                sex: row.gender,
                description: row.description,
                price: row.price,
                supplierId: row.supplierId,
                stockMin: row.stockMin,
                stockQuantity: 0,
                quantityLock: 0,
                photo: "",
                zone: "1",
            }));

            this.$emit("executeCreateProducts", productsToSend);
        },

        readExcelFile() {
            if (!this.currentFile) return;

            this.loading = true;
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = e.target.result;

                    // 1. Leer el libro
                    const workbook = XLSX.read(data, { type: "array" });

                    // 2. Tomar la primera hoja
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // 3. Convertir a JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    console.log(
                        "🚀 Datos leídos del Excel:",
                        jsonData,
                        this.headers,
                    );

                    if (jsonData.length > 0) {
                        const processedData = jsonData.map((excelRow) => {
                            const row = this.processRow(excelRow);
                            //row.id = this.products.find(p => p.name == excelRow.product)?.id || null;
                            return row;
                        });

                        this.excelData = processedData;
                    } else {
                        console.warn(
                            "El archivo Excel está vacío o no se pudo leer correctamente.",
                        );
                    }
                } catch (error) {
                    console.error("Error al leer el archivo Excel:", error);
                } finally {
                    this.loading = false;
                }
            };

            reader.readAsArrayBuffer(this.currentFile);
        },

        processRow(excelRow) {
            const errors = [];

            // Validar categoría
            const category = this.categories.find(
                (c) =>
                    c.text.toUpperCase() ===
                    (excelRow.category || "").trim().toUpperCase(),
            );
            const categoryId = category?.value ?? null;
            if (!categoryId) {
                errors.push(`Categoría '${excelRow.category}' no existe`);
            }

            // Validar proveedor
            const supplier = this.suppliers.find(
                (s) =>
                    s.text.toUpperCase() ===
                    (excelRow.provideer || excelRow.supplier || "")
                        .trim()
                        .toUpperCase(),
            );
            const supplierId = supplier?.value ?? null;
            if (!supplierId) {
                errors.push(
                    `Proveedor '${excelRow.provideer || excelRow.supplier}' no existe`,
                );
            }

            // Guardar nombres para mostrar en tabla
            const categoryName = category?.text ?? (excelRow.category || "");
            const supplierName =
                supplier?.text ??
                (excelRow.provideer || excelRow.supplier || "");

            // Validar género (solo F, M, U)
            const gender = (excelRow.gender || "").trim().toUpperCase() || "U";
            if (!["F", "M", "U"].includes(gender)) {
                errors.push(
                    `Género '${excelRow.gender}' inválido (solo F, M, U)`,
                );
            }

            // Validar campos obligatorios
            const code = excelRow.code;
            const size = (excelRow.size || "").trim().toUpperCase();
            const description = (excelRow.description || "").trim();
            const price = excelRow.price;
            const stockMin = excelRow.stockMin ?? 0;

            if (!code) errors.push("Código es obligatorio");
            if (!size) errors.push("Talla es obligatoria");
            if (!description) errors.push("Descripción es obligatoria");
            if (price === null || price === undefined)
                errors.push("Precio es obligatorio");

            // Verificar si producto YA existe (code === name) - ERROR si existe
            const existingProduct = this.products.find((p) => p.name == code);
            if (existingProduct) {
                errors.push(`Producto con código '${code}' ya existe`);
            }

            // Determinar flag y errores
            const flag = errors.length === 0;

            if (!flag) {
                this.hasErrors = true;
            }

            return {
                flag,
                errors: errors.join(", "),
                category: categoryName,
                categoryId,
                code,
                size,
                gender,
                description,
                price,
                supplier: supplierName,
                supplierId,
                stockMin,
            };
        },
    },
};
</script>

<style scoped>
.custom-font {
    font-size: 0.9rem;
}
</style>
